import { NumberFormat } from "../../../utils/tools";
import Propertie from "../../_model/ModelEngineeringProperties"

const ValueOnStrucutre = {
  get(structure = {} , prop = new Propertie){
    let type;
    try {
      type = func.getType(prop)
      switch (type){
        case "current":
          return func.getCurrent(structure, prop)

        case "operationAttributes":
          return func.getOperationAttribute(structure, prop);

        case "operationEquipments":
          return func.getOperationEquipment(structure, prop) ;

        case "internalCurrentAttibutes":
          return func.getInternalCurrentAtrributes(structure, prop)

        case "internalCurrentComponents":
          return func.getInternalCurrentComponents(structure, prop)
      }
    } catch (e) {
      return;
    }
  },

  set(structure = {} , prop = new Propertie){
    let type = "";
    try {
      type = func.getType(prop)
      switch (type){
        case "current":
          func.setCurrent(structure, prop)
          break;
        case "operationAttributes":
          func.setOperationAttribute(structure, prop);
          break;
        case "operationEquipments":
          func.setOperationEquipment(structure, prop) ;
          break;
        case "internalCurrentAttibutes":
          func.setInternalCurrentAtrributes(structure, prop)
          break;
        case "internalCurrentComponents":
          func.setInternalCurrentComponents(structure, prop)
      }
    } catch (e) {
      return;
    }
  }
}

export default ValueOnStrucutre

const func = {
  getType(prop = new Propertie){
    if (prop.type == "Correntes") {
      return "current"
    } else if (prop.type == "Operações") {
        if (prop.subType == "Atributos")
          return "operationAttributes"
        else if (prop.subType == "Equipamentos")
           return "operationEquipments"
    } else if (prop.type == "CorrenteInterna")
        if(prop.subType == "Atributos")
          return "internalCurrentAttibutes"
        else
          return "internalCurrentComponents"
  },

  setCurrent: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index][prop.propIndex][prop.propName][prop.key] = NumberFormat(prop.value),
  getCurrent: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index][prop.propIndex][prop.propName][prop.key],

  setOperationAttribute: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index].Atributos[prop.key] = NumberFormat(prop.value),
  getOperationAttribute: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index].Atributos[prop.key],

  setOperationEquipment: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index].Equipamentos[prop.equipName][prop.key] = NumberFormat(prop.value),
  getOperationEquipment: (structure = {}, prop = new Propertie) => structure[prop.type][prop.index].Equipamentos[prop.equipName][prop.key],

  setInternalCurrentAtrributes: (structure = {}, prop = new Propertie) => structure["Operações"][prop.index]["Correntes"][prop.component][prop.subType][prop.key] = NumberFormat(prop.value),
  getInternalCurrentAtrributes: (structure = {}, prop = new Propertie) => structure["Operações"][prop.index]["Correntes"][prop.component][prop.subType][prop.key],

  setInternalCurrentComponents: (structure = {}, prop = new Propertie) => structure["Operações"][prop.index]["Correntes"][prop.component]["Componentes"][prop.subType][prop.key] = NumberFormat(prop.value),
  getInternalCurrentComponents: (structure = {}, prop = new Propertie) => structure["Operações"][prop.index]["Correntes"][prop.component]["Componentes"][prop.subType][prop.key],
}